var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrapper not-found-box"},[_c('empty',{attrs:{"image":"network","description":"无法找到页面"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }